// 取消预订
import { OccType, PriceChannel } from '@/config/constant';
import { ReserveCancelAction } from '@/redux/actions/reservation/constant';
import { ChannelItem } from '@/redux/reducers/reservation/base';

export interface RentRecordInfo {
  indexId: string; // 唯一标识
  resvNo: string; // 主单号
  recNo: string; // 子单号
  roomTypeName: string; // 房型名称
  roomNo: string; // 房间号
  occType: OccType; // 入住类型
  expectedArrivalTime: number; // 预抵时间
  expectedDepartureTime: number; // 预离时间
  occDuration: number; // 入住时长
  liquidatedDamages: string; // 违约金
  priceChannel: PriceChannel; // 订单渠道
}

export interface MainState {
  rentRecordList: RentRecordInfo[]; // 子单列表
  channelList?: ChannelItem[]; // 渠道列表
}

export interface ReducerState extends MainState {
  isInit: boolean; // 初始化
  isLoading: boolean; // 加载中
}

type ActionHandler<T> = (state: ReducerState, action: { payload: T }) => ReducerState;

const initialState: Partial<ReducerState> = {
  isInit: false,
  isLoading: true,
  rentRecordList: [],
  channelList: [],
};

const reducerMap = {
  [ReserveCancelAction.initDefaultState]: <ActionHandler<Partial<ReducerState>>>((
    state,
    { payload },
  ) => {
    return { ...state, ...payload };
  }),
  [ReserveCancelAction.setLoadingStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, isLoading: payload };
  }),
  [ReserveCancelAction.setInitStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, isInit: payload };
  }),
  [ReserveCancelAction.setRentRecordList]: <ActionHandler<RentRecordInfo[]>>((
    state,
    { payload },
  ) => {
    return { ...state, rentRecordList: payload };
  }),
  [ReserveCancelAction.setChannelList]: <ActionHandler<ChannelItem[]>>((state, { payload }) => {
    return { ...state, channelList: payload };
  }),
};

export const reducerMapper = (state = initialState, action) => {
  const actionType = action.type;
  const reducer = reducerMap[actionType];
  if (typeof reducer === 'function') {
    return reducer(<ReducerState>state, action);
  }
  return state;
};

export const storeName = 'cancelReserve';
